module.exports = __webpack_public_path__ + "img/404.6695af99.svg";